import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { listApplicationsInfiniteQuery } from '@/features/provider-panel/applications/api/applicationsListApi';
import { APPLICATIONS_PER_PAGE } from '@/components/ui/applications/constants';
import { crownQueryClient } from '@/common/api/crownQueryClient';
import { zodValidator } from '@tanstack/zod-adapter';
import { applicationFilters } from '@/common/schema/applicationFiltersSchema';
import { getZodDefaults } from '@/common/util/getZodDefaults';
import { ApplicationsIndex } from '@/features/provider-panel/applications/ApplicationsIndex.tsx';

export const Route = createFileRoute('/provider/$providerId/applications/')({
  validateSearch: zodValidator(applicationFilters),
  search: {
    middlewares: [stripSearchParams(getZodDefaults(applicationFilters))],
  },
  loader: ({ params }) =>
    crownQueryClient.ensureInfiniteQueryData(
      listApplicationsInfiniteQuery({
        providerId: params.providerId,
        limit: APPLICATIONS_PER_PAGE,
        filters: { search: '', status: ['PROVIDER_FILLING'] },
      }),
    ),
  component: ApplicationsIndex,
})
